import { Box, Button, Stack, Typography } from '@mui/material'
import { ActionProgress } from './components/ActionProgress'
import { ProvidersAutocomplete } from './components/Autocomplete'
import { useLoading } from './hooks/useLoading'
import { useTransferForm } from './hooks/useTransferForm'
import { useTransferMediaOwnership } from './hooks/useTransferMediaOwnership'
import type { PageProps } from './types'

export function TransferOwnership({ options, openModal, sx }: PageProps) {
  const filteredOptions = options.filter((p) => p.ownsMedia === true)
  const { form, update, reset } = useTransferForm(filteredOptions, options)
  const { transferMedia } = useTransferMediaOwnership()
  const { transferLoading, loading } = useLoading()
  const disabled = loading || !form.from || !form.to

  const onClick = () => {
    const { from, to } = form
    if (!from || !to) return
    openModal(
      <Typography>
        Do you wish to transfer media from{' '}
        <span style={{ fontWeight: 600 }}>{from.displayName}</span> to{' '}
        <span style={{ fontWeight: 600 }}>{to.displayName}</span>?
      </Typography>,
      async () => {
        const ok = await transferMedia({
          currentOwnerCwsId: from.cwsId,
          newOwnerCwsId: to.cwsId,
        })
        if (ok) reset()
      },
      true,
    )
  }

  return (
    <Box>
      <Typography variant='h4' gutterBottom>
        Transfer Ownership
      </Typography>

      <Stack direction='row' gap={2}>
        <ProvidersAutocomplete
          labelSuffix='From'
          options={filteredOptions.filter((p) => p.cwsId !== form.to?.cwsId)}
          value={form.from}
          onChange={(v) => update({ from: v })}
        />
        <ProvidersAutocomplete
          labelSuffix='To'
          options={options.filter((p) => p.cwsId !== form.from?.cwsId)}
          value={form.to}
          onChange={(v) => update({ to: v })}
        />
        <Button
          name='transfer'
          variant='contained'
          size='large'
          disabled={disabled}
          onClick={onClick}
          sx={sx}
        >
          {transferLoading ? (
            <ActionProgress label='Transferring' />
          ) : (
            'Transfer'
          )}
        </Button>
      </Stack>
    </Box>
  )
}
